/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReturnInfoVo
 */
export interface ReturnInfoVo {
    /**
     * 订单id
     * @type {number}
     * @memberof ReturnInfoVo
     */
    orderId?: number;
    /**
     * 退货方式 1 退货标签(附件）2 退货标签（箱内附带）3 退货申请编号 4 使用中心快递
     * @type {number}
     * @memberof ReturnInfoVo
     */
    returnMethod?: number;
    /**
     * 退货标签文件 url
     * @type {string}
     * @memberof ReturnInfoVo
     */
    returnFlagFile?: string;
    /**
     * 备注
     * @type {string}
     * @memberof ReturnInfoVo
     */
    remark?: string;
    /**
     * 收货人姓名
     * @type {string}
     * @memberof ReturnInfoVo
     */
    receiverName?: string;
    /**
     * 收货人手机号
     * @type {string}
     * @memberof ReturnInfoVo
     */
    receiverPhone?: string;
    /**
     * 收货人地址
     * @type {string}
     * @memberof ReturnInfoVo
     */
    receiverAddress?: string;
    /**
     * 收货人地址详情
     * @type {string}
     * @memberof ReturnInfoVo
     */
    receiverAddressDetail?: string;
    /**
     * 邮编
     * @type {string}
     * @memberof ReturnInfoVo
     */
    returnZip?: string;
    /**
     * 退货订单 取货方式1 仓库快递 2 卖家回收
     * @type {number}
     * @memberof ReturnInfoVo
     */
    returnFetchGoodsMethod?: number;
    /**
     * 退货订单取货码
     * @type {string}
     * @memberof ReturnInfoVo
     */
    returnFetchGoodsCode?: string;
    /**
     * 退货订单取货时间
     * @type {string}
     * @memberof ReturnInfoVo
     */
    returnFetchGoodsDate?: string;
}

/**
 * Check if a given object implements the ReturnInfoVo interface.
 */
export function instanceOfReturnInfoVo(value: object): value is ReturnInfoVo {
    return true;
}

export function ReturnInfoVoFromJSON(json: any): ReturnInfoVo {
    return ReturnInfoVoFromJSONTyped(json, false);
}

export function ReturnInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'returnMethod': json['returnMethod'] == null ? undefined : json['returnMethod'],
        'returnFlagFile': json['returnFlagFile'] == null ? undefined : json['returnFlagFile'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'receiverPhone': json['receiverPhone'] == null ? undefined : json['receiverPhone'],
        'receiverAddress': json['receiverAddress'] == null ? undefined : json['receiverAddress'],
        'receiverAddressDetail': json['receiverAddressDetail'] == null ? undefined : json['receiverAddressDetail'],
        'returnZip': json['returnZip'] == null ? undefined : json['returnZip'],
        'returnFetchGoodsMethod': json['returnFetchGoodsMethod'] == null ? undefined : json['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': json['returnFetchGoodsCode'] == null ? undefined : json['returnFetchGoodsCode'],
        'returnFetchGoodsDate': json['returnFetchGoodsDate'] == null ? undefined : json['returnFetchGoodsDate'],
    };
}

export function ReturnInfoVoToJSON(json: any): ReturnInfoVo {
    return ReturnInfoVoToJSONTyped(json, false);
}

export function ReturnInfoVoToJSONTyped(value?: ReturnInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'returnMethod': value['returnMethod'],
        'returnFlagFile': value['returnFlagFile'],
        'remark': value['remark'],
        'receiverName': value['receiverName'],
        'receiverPhone': value['receiverPhone'],
        'receiverAddress': value['receiverAddress'],
        'receiverAddressDetail': value['receiverAddressDetail'],
        'returnZip': value['returnZip'],
        'returnFetchGoodsMethod': value['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': value['returnFetchGoodsCode'],
        'returnFetchGoodsDate': value['returnFetchGoodsDate'],
    };
}

